import { render, staticRenderFns } from "./patrolTab.vue?vue&type=template&id=4aee46de"
import script from "./patrolTab.vue?vue&type=script&lang=js"
export * from "./patrolTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4aee46de')) {
      api.createRecord('4aee46de', component.options)
    } else {
      api.reload('4aee46de', component.options)
    }
    module.hot.accept("./patrolTab.vue?vue&type=template&id=4aee46de", function () {
      api.rerender('4aee46de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/patrol/patrolTab.vue"
export default component.exports